// Mock data for Jetco Electrical Contractors Landing Page

export const companyInfo = {
  name: "Jetco Electrical Contractors LLC",
  tagline: "Your Trusted Brooklyn Electrical Experts",
  phone: "(667) 455-6368",
  email: "Jetcoelectricllc@gmail.com",
  website: "jetcoelectrical.com",
  hours: "24/7 Emergency Service Available",
  locations: [
    "647 E 89th St, Brooklyn, NY 11236"
  ],
  serviceAreas: {
    brooklyn: ["Williamsburg", "Park Slope", "Bay Ridge", "Flatbush", "Bensonhurst", "Canarsie"],
    queens: ["Astoria", "Flushing", "Long Island City", "Forest Hills", "Jamaica"],
    manhattan: ["Upper East Side", "Upper West Side", "Midtown", "Chelsea", "Lower East Side"]
  }
};

export const services = [
  {
    id: 1,
    title: "Circuit Box Repairs",
    description: "Fast, professional diagnosis and repair of tripping breakers, hot panels, and unsafe fuse boxes in Brooklyn homes and businesses.",
    icon: "Grid3x3",
    image: "https://images.pexels.com/photos/32497160/pexels-photo-32497160.jpeg",
    features: ["Breaker Replacement", "Bus-Bar Repair", "FPE / Zinsco Removal", "Same-Day Service"]
  },
  {
    id: 2,
    title: "Electrical Contracting",
    description: "Full-service electrical contracting — plans, permits, rough-in, and DOB sign-off for residential and commercial projects.",
    icon: "HardHat",
    image: "https://images.pexels.com/photos/5667685/pexels-photo-5667685.jpeg",
    features: ["Code-Compliant Work", "DOB Plan Filing", "GC Coordination", "Bonded & Insured"]
  },
  {
    id: 3,
    title: "Equipment Assembly",
    description: "Onsite assembly and electrical hookup for commercial kitchen, lab, medical, and office equipment.",
    icon: "Wrench",
    image: "https://images.pexels.com/photos/37717004/pexels-photo-37717004.jpeg",
    features: ["Dedicated Circuits", "208V / 240V / 3-Phase", "Vendor Coordination", "Load Verification"]
  },
  {
    id: 4,
    title: "EV Charger Installation",
    description: "Tesla Wall Connector and Level 2 charger installation, permitted and inspected, with up to $1,000 in federal tax credits.",
    icon: "Plug",
    image: "https://images.pexels.com/photos/27355833/pexels-photo-27355833.jpeg",
    features: ["Tesla Recommended", "Level 2 / 40A / 60A", "30C Tax Credit", "Permitted & Inspected"]
  },
  {
    id: 5,
    title: "Furniture Assembly",
    description: "Professional assembly and wall-mounting of IKEA, Wayfair, West Elm, and direct-to-consumer furniture across NYC.",
    icon: "Hammer",
    image: "https://images.unsplash.com/photo-1645651964715-d200ce0939cc?w=1200",
    features: ["IKEA / Wayfair / West Elm", "Wall Mounting", "Murphy Beds & TVs", "Same-Day Service"]
  },
  {
    id: 6,
    title: "Generator Installation",
    description: "Whole-house Generac and Kohler standby generators plus permitted portable-generator inlet boxes for Brooklyn homes.",
    icon: "BatteryCharging",
    image: "https://images.unsplash.com/photo-1612194092957-c182f4de4433?w=1200",
    features: ["Generac & Kohler", "Automatic Transfer Switch", "Gas Line Coordination", "Annual Maintenance"]
  },
  {
    id: 7,
    title: "Home Setup",
    description: "Single-visit move-in setup combining TV mounting, smart switches, internet wiring, and surge protection for new Brooklyn homes.",
    icon: "Home",
    image: "https://images.unsplash.com/photo-1616440347437-b1c73416efc2?w=1200",
    features: ["TV Mounting", "Smart Switches & Dimmers", "Ethernet & WiFi", "Surge Protection"]
  },
  {
    id: 8,
    title: "Outdoor Electrical Services",
    description: "Weatherproof outdoor outlets, landscape lighting, hot-tub circuits, and exterior security wiring rated for NYC weather.",
    icon: "Sun",
    image: "https://images.pexels.com/photos/34581643/pexels-photo-34581643.jpeg",
    features: ["GFCI / WR Receptacles", "Landscape Lighting", "Hot Tub Circuits", "Holiday Light Outlets"]
  },
  {
    id: 9,
    title: "Recessed Lighting",
    description: "LED wafer recessed lighting design and installation for Brooklyn brownstones, condos, and commercial spaces.",
    icon: "Lightbulb",
    image: "https://images.unsplash.com/photo-1649083048770-82e8ffd80431?w=1200",
    features: ["LED Wafer Fixtures", "Tunable White 2700-5000K", "Lutron Caséta Dimmers", "Plaster Ceiling Capable"]
  },
  {
    id: 10,
    title: "Residential and Commercial Electrical Service",
    description: "End-to-end residential and commercial electrical service from a single contractor — one team, one point of contact.",
    icon: "Building2",
    image: "https://images.pexels.com/photos/8853472/pexels-photo-8853472.jpeg",
    features: ["Service Upgrades", "Tenant Build-Outs", "24/7 Emergency Service", "1-Year Warranty"]
  },
  {
    id: 11,
    title: "Smart Home System Installation",
    description: "Lutron Caséta, Leviton, HomeKit, Google Home, and Alexa smart-home installation — including neutral-wire retrofits.",
    icon: "Cpu",
    image: "https://images.pexels.com/photos/17828637/pexels-photo-17828637.jpeg",
    features: ["Lutron Caséta Certified", "HomeKit / Google / Alexa", "Neutral-Wire Retrofits", "Scene Programming"]
  },
  {
    id: 12,
    title: "Christmas Light Installation",
    description: "Professional holiday light design, installation, maintenance, and takedown for Brooklyn homes and businesses.",
    icon: "Sparkles",
    image: "https://images.unsplash.com/photo-1789931123762-25ed9458c586?w=1200",
    features: ["Custom Roofline Design", "Commercial-Grade LEDs", "Dusk-to-Dawn Timers", "January Takedown Included"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael Rodriguez",
    location: "Brooklyn, NY",
    rating: 5,
    text: "Jetco installed our Tesla Wall Connector quickly and professionally. The team was knowledgeable and the installation was clean. Highly recommend!",
    service: "EV Charger Installation"
  },
  {
    id: 2,
    name: "Sarah Chen",
    location: "Long Island, NY",
    rating: 5,
    text: "We had an electrical emergency at 2 AM and Jetco responded immediately. They fixed the issue quickly and professionally. True 24/7 service!",
    service: "Emergency Repair"
  },
  {
    id: 3,
    name: "David Thompson",
    location: "St. Albans, NY",
    rating: 5,
    text: "Our electrical panel upgrade was completed ahead of schedule. The work was top-notch and passed inspection on the first try. Professional team!",
    service: "Panel Upgrade"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    icon: "Award",
    title: "Experienced Professionals",
    description: "Over 15 years of expertise in residential and commercial electrical work."
  },
  {
    id: 2,
    icon: "Clock",
    title: "24/7 Availability",
    description: "Emergency services available around the clock, every day."
  },
  {
    id: 3,
    icon: "Users",
    title: "Expert Team",
    description: "Experienced electricians with extensive training and expertise."
  },
  {
    id: 4,
    icon: "CheckCircle2",
    title: "Quality Guaranteed",
    description: "We stand behind our work with comprehensive warranties."
  }
];
